import React from "react";
import {
  browserLocalPersistence,
  GoogleAuthProvider,
  setPersistence,
  signInWithPopup,
  signInWithRedirect,
} from "firebase/auth";
import { useGoogleAuthContext } from "../../contexts/GoogleAuthContext";
import { Box, Card, FormControl, Typography } from "@mui/material";
import { Google, BemViver } from "../../assets/images";

export function LoginApp() {
  const { auth } = useGoogleAuthContext();

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });

    try {
      await setPersistence(auth, browserLocalPersistence);

      // Em ambientes onde redirect perde estado, popup costuma ser mais confiavel.
      await signInWithPopup(auth, provider);
    } catch (error) {
      const code = (error as { code?: string })?.code;

      if (
        code === "auth/popup-blocked" ||
        code === "auth/operation-not-supported-in-this-environment"
      ) {
        try {
          await signInWithRedirect(auth, provider);
          return;
        } catch (redirectError) {
          console.error("LoginApp: Erro no fallback com redirect:", redirectError);
          return;
        }
      }

      console.error("LoginApp: Erro no login:", error);
    }
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#00FF00",
      }}
    >
      <Box style={{ marginTop: "100px", marginBottom: "100px" }}>
        <img src={BemViver} alt="Bem Viver" />
      </Box>
      <Box
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Box
          style={{
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            borderTopLeftRadius: "64px",
            borderTopRightRadius: "64px",
            position: "relative",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "calc(100% - 64px)",
            }}
          >
            <Box style={{ position: "absolute", top: 64 }}>
              <Typography
                color="#376FCA"
                variant="h4"
                fontWeight="bold"
                marginLeft={"20px"}
                marginRight={"20px"}
              >
                Seja bem-vindo ao Admin!
              </Typography>
            </Box>

            <FormControl fullWidth>
              <button
                style={{
                  backgroundColor: "white",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={handleGoogleSignIn}
              >
                <Card
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "64px",
                    borderRadius: "16px",
                    borderColor: "#E4E6E8",
                    border: "1px solid #E4E6E8",
                    boxShadow: "none",
                  }}
                >
                  <Box
                    style={{
                      position: "absolute",
                      left: 0,
                      marginLeft: "16px",
                    }}
                  >
                    <img src={Google} alt="Google" style={{ width: "60px" }} />
                  </Box>
                  <Typography
                    style={{ justifySelf: "center" }}
                    fontWeight="bold"
                    color="#535676"
                    fontSize="medium"
                  >
                    Entrar
                  </Typography>
                </Card>
              </button>
            </FormControl>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LoginApp;
